import { cn } from "@/lib/utils";

const MAP = {
  Pass: "bg-[#DCFCE7] text-[#166534] border-[#22C55E]/40",
  Failed: "bg-[#FEE2E2] text-[#991B1B] border-[#EF4444]/40",
  Pending: "bg-[#FEF3C7] text-[#92400E] border-[#F59E0B]/40",
  Available: "bg-[#E0F2FE] text-[#075985] border-[#0EA5E9]/40",
  Sold: "bg-slate-100 text-slate-600 border-slate-300",
  Holding: "bg-slate-100 text-slate-700 border-slate-300",
  Open: "bg-[#E0F2FE] text-[#075985] border-[#0EA5E9]/40",
  Completed: "bg-[#DCFCE7] text-[#166534] border-[#22C55E]/40",
};

export default function StatusBadge({ status, testId }) {
  const cls = MAP[status] || "bg-slate-100 text-slate-700 border-slate-300";
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full border text-xs font-medium",
        cls
      )}
      data-testid={testId}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70" />
      {status}
    </span>
  );
}
